/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_More_UpdatesInputs */

const en_learn_more_updates = /** @type {(inputs: Learn_More_UpdatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn More about Updates`)
};

const fr_learn_more_updates = /** @type {(inputs: Learn_More_UpdatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En savoir plus sur les mises à jour`)
};

const de_learn_more_updates = /** @type {(inputs: Learn_More_UpdatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfahren Sie mehr über Updates`)
};

const it_learn_more_updates = /** @type {(inputs: Learn_More_UpdatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri di più sugli aggiornamenti`)
};

const ru_learn_more_updates = /** @type {(inputs: Learn_More_UpdatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Узнайте больше об обновлениях`)
};

const es_learn_more_updates = /** @type {(inputs: Learn_More_UpdatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenga más información sobre las actualizaciones`)
};

const zh_cn2_learn_more_updates = /** @type {(inputs: Learn_More_UpdatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解更多更新信息`)
};

const ja_learn_more_updates = /** @type {(inputs: Learn_More_UpdatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップデートの詳細`)
};

const hi_learn_more_updates = /** @type {(inputs: Learn_More_UpdatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपडेट के बारे में और जानें`)
};

const pt_pt2_learn_more_updates = /** @type {(inputs: Learn_More_UpdatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saiba mais sobre as atualizações.`)
};

/**
* | output |
* | --- |
* | "Learn More about Updates" |
*
* @param {Learn_More_UpdatesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const learn_more_updates = /** @type {((inputs?: Learn_More_UpdatesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_More_UpdatesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_learn_more_updates(inputs)
	if (locale === "de") return de_learn_more_updates(inputs)
	if (locale === "it") return it_learn_more_updates(inputs)
	if (locale === "ru") return ru_learn_more_updates(inputs)
	if (locale === "es") return es_learn_more_updates(inputs)
	if (locale === "zh-CN") return zh_cn2_learn_more_updates(inputs)
	if (locale === "ja") return ja_learn_more_updates(inputs)
	if (locale === "hi") return hi_learn_more_updates(inputs)
	if (locale === "pt-PT") return pt_pt2_learn_more_updates(inputs)
	return en_learn_more_updates(inputs)
});